import React, { useState, useEffect } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Checkbox from '@material-ui/core/Checkbox';

import { Container } from './styles';
import { useSubpoenaList, markSubpoenaAs } from './props';
import SubpoenaItem from 'component/subpoenas-item';
import { useHistory } from 'react-router';

function Subpoena() {
  const [selectedItems, setSelectedItems] = useState([]);
  const { subpoenas, isLoading, setSubpoenasStatus } = useSubpoenaList();
  const [allChecked, setAllChecked] = useState(false);
  const { push } = useHistory();

  const toggleSelection = id => {
    setSelectedItems(prev => {
      const shallow = prev.slice();

      if (shallow.includes(id)) {
        shallow.splice(
          shallow.findIndex(item => item === id),
          1
        );

        return shallow;
      }

      shallow.push(id);

      return shallow;
    });
  };

  useEffect(() => {
    if (selectedItems.length !== subpoenas.length) {
      setAllChecked(false);
    } else {
      setAllChecked(true);
    }
  }, [subpoenas, selectedItems]);

  const markAllAs = async isRead => {
    setSelectedItems(() => {
      return !isRead ? [] : subpoenas.map(item => item.id);
    });
  };

  const changeItemsStatus = async status => {
    const isSuccess = await markSubpoenaAs(selectedItems, status);

    if (isSuccess) {
      setSubpoenasStatus(selectedItems, status);
    }
  };

  const processItem = async id => {
    const isSuccess = await markSubpoenaAs([id], 'PROCESSED');

    if (isSuccess) {
      setSubpoenasStatus([id], 'PROCESSED');

      let clippingCross = subpoenas.find(item => item.id === id);
      const date = new Date(clippingCross.availabilityDate);

      const weekDay = [
        'domingo',
        'segunda-feira',
        'terça-feira',
        'quarta-feira',
        'quinta-feira',
        'sexta-feira',
        'sábado',
      ][date.getDay()];
      const day = date.getDate();
      const month = [
        'janeiro',
        'fevereiro',
        'março',
        'abril',
        'maio',
        'junho',
        'julho',
        'agosto',
        'setembro',
        'outubro',
        'novembro',
        'dezembro',
      ][date.getMonth()];

      clippingCross = `${clippingCross.journalName} 
Disponibilização:   ${weekDay}, ${day} de ${month} de ${date.getFullYear()}.
${clippingCross.text}`;

      push({
        pathname: '/novo-recorte',
        state: {
          clippingCross,
        },
      });
    }
  };

  const setItemAsRead = async id => {
    const isSuccess = await markSubpoenaAs([id], 'READ');
    if (isSuccess) {
      setSubpoenasStatus([id], 'READ');
    }
  };

  if (!subpoenas || subpoenas.length === 0)
    return (
      <Container>
        <div className="container-feedback">
          {isLoading ? <CircularProgress /> : 'Nenhuma intimação para exibir'}
        </div>
      </Container>
    );

  return (
    <Container>
      <div className="actions">
        <div className="actions__checkbox">
          <Checkbox
            checked={allChecked}
            onChange={e => {
              markAllAs(e.target.checked);
              setAllChecked(e.target.checked);
            }}
          />

          <span className="actions__selected-items">
            {selectedItems.length === 0
              ? 'Nenhuma selecionada'
              : `${selectedItems.length} selecionada${
                  selectedItems.length === 0 || selectedItems.length > 1
                    ? 's'
                    : ''
                }`}
          </span>
        </div>

        {selectedItems.length > 0 && (
          <div className="actions__buttons">
            <span>Marcar {selectedItems.length} como</span>
            <button
              onClick={() => {
                changeItemsStatus('READ');
              }}
            >
              Lido
            </button>
            <span>ou</span>
            <button
              onClick={() => {
                changeItemsStatus('UNREAD');
              }}
            >
              Não lido
            </button>
          </div>
        )}
      </div>

      {subpoenas.map(subpoena => (
        <SubpoenaItem
          key={subpoena.id}
          {...subpoena}
          onSelectClick={toggleSelection}
          onSeeMoreClick={setItemAsRead}
          onProcessClick={processItem}
          isSelected={selectedItems.includes(subpoena.id)}
        />
      ))}
    </Container>
  );
}

export default Subpoena;
